<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },

    seamless: {
      type: Boolean,
      default: false
    },

    footerClass: {
      type: String,
      default: ''
    },

    footerStickingClass: {
      type: String,
      default: ''
    },

    footerStyle: {
      type: String,
      default: ''
    },

    footerStickingStyle: {
      type: String,
      default: ''
    },

    sticky: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isFooterSticking: false
  }),

  computed: {
    listeners() {
      if (!this.$listeners.submit) {
        return this.$listeners
      }

      return {
        ...this.$listeners,
        submit: (event) => {
          event.preventDefault()

          this.$listeners.submit(event)
        }
      }
    },

    hasActionsSlot() {
      return !!this.$slots.actions || !!this.$scopedSlots.actions
    }
  },

  mounted() {
    if (this.sticky) {
      this.setupStickyFooter()
    }
  },

  beforeDestroy() {
    if (this.stickyFooterObserver) {
      this.stickyFooterObserver.disconnect()
      this.stickyFooterObserver = null
    }
  },

  methods: {
    setupStickyFooter() {
      if (!this.hasActionsSlot || !this.$refs.footerRef) {
        return
      }

      const footerBottom = window.getComputedStyle(this.$refs.footerRef).bottom
      let observableFooterBottom = -1

      if (footerBottom) {
        observableFooterBottom = parseFloat(footerBottom.replace('px', '')) - 1
      }

      this.$refs.footerRef.style.bottom = `${observableFooterBottom}px`

      this.stickyFooterObserver = new IntersectionObserver(([el]) => {
        this.isFooterSticking = el.intersectionRatio < 1
      }, { threshold: 1 })
      this.stickyFooterObserver.observe(this.$refs.footerRef)
    }
  }
}
</script>

<template>
  <form
    class="relative flex flex-col bg-white rounded"
    :class="{
      'shadow border-grey-300 border': !seamless
    }"
    v-bind="$attrs"
    v-on="listeners"
  >
    <mia-fade-transition mode="out-in">
      <div
        v-if="isLoading"
        key="is-loading"
        class="absolute inset-0 flex items-center justify-center bg-gray-300"
      >
        <mia-wave-loader />
      </div>
      <div
        v-else
        key="has-loaded"
        class="flex flex-col justify-between flex-1"
      >
        <div :class="{ 'rounded-b': !hasActionsSlot }">
          <slot />
        </div>
        <div
          v-if="hasActionsSlot"
          ref="footerRef"
          class="footer flex items-center justify-end p-4 bg-gray-100 rounded-b"
          :class="[footerClass || '', sticky ? 'sticky' : '', sticky && isFooterSticking ? (footerStickingClass || '') : ''].filter(Boolean)"
          :style="[footerStyle || '', sticky && isFooterSticking ? (footerStickingStyle || '') : ''].filter(Boolean).join(';')"
        >
          <slot
            name="actions"
            :sticky="isFooterSticking"
          />
        </div>
      </div>
    </mia-fade-transition>
  </form>
</template>

<style scoped>
.footer:empty {
  display: none;
}
</style>
